import React from 'react';

const ImagePlaceholder = ({ 
  width = '100%', 
  height = '200px', 
  text = '📄 No Image Available',
  fontSize = '0.9rem',
  backgroundColor = '#f8f9fa',
  borderColor = '#dee2e6',
  textColor = '#6c757d'
}) => {
  return (
    <div style={{
      width,
      height,
      backgroundColor,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: textColor,
      fontSize,
      border: `1px dashed ${borderColor}`,
      borderRadius: '8px'
    }}>
      {text}
    </div>
  );
};

export default ImagePlaceholder;
